goog.provide("shadow.js.shim.module$$carbon$icons_react$es$Draggable$default");
shadow.js.shim.module$$carbon$icons_react$es$Draggable$default = shadow.js.require(361, {}).default;
